export enum logroTypesEnum {
    RELLENAR_LOGRO = 'RELLENAR_LOGRO'
  }